export default __webpack_public_path__ + "static/media/element_88.0332bdd5.webp";